<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M11.5 29.5h25v-18h-25v18zm28 0V11A2.5 2.5 0 0037 8.5H11A2.5 2.5 0 008.5 11v18.5H6A1.5 1.5 0 004.5 31v4a5.5 5.5 0 005.5 5.5h28a5.5 5.5 0 005.5-5.5v-4a1.5 1.5 0 00-1.5-1.5h-2.5zm1 3h-33V35a2.5 2.5 0 002.5 2.5h28a2.5 2.5 0 002.5-2.5v-2.5zM21 14a1 1 0 100 2h6a1 1 0 100-2h-6z"/></svg>